/* Linsoul feature video: muted loop plays only while on screen (none under reduced motion until the visitor presses play),
   pause/play button, optional slide switcher with a GSAP stagger when several slides exist. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.dataset.lfvReady) return;
    root.dataset.lfvReady = '1';
    const slides = [...root.querySelectorAll('[data-lfv-slide]')];
    if (!slides.length) return;
    const count = root.querySelector('[data-lfv-count]');
    const pad = (n) => String(n).padStart(2, '0');
    let index = 0;
    let inView = false;
    const userPaused = new WeakMap();

    const mediaOf = (slide) => slide.querySelector('.lfv__media');
    const videoOf = (slide) => slide.querySelector('[data-lfv-video]');

    const sync = () => {
      slides.forEach((slide, i) => {
        const v = videoOf(slide);
        if (!v) return;
        const want = i === index && inView && !document.hidden && !userPaused.get(v);
        if (want) {
          if (v.preload === 'none') v.preload = 'metadata';
          const p = v.play();
          if (p && p.catch) p.catch(() => mediaOf(slide).classList.add('is-paused'));
        } else if (!v.paused) {
          v.pause();
        }
        mediaOf(slide).classList.toggle('is-paused', !!userPaused.get(v) || (i === index && v.paused && !want));
      });
    };

    slides.forEach((slide) => {
      const v = videoOf(slide);
      const btn = slide.querySelector('[data-lfv-toggle]');
      if (!v || !btn) return;
      if (reduced.matches || root.hasAttribute('data-design-mode')) userPaused.set(v, true);
      const label = () => btn.setAttribute('aria-label', userPaused.get(v) ? root.dataset.playLabel : root.dataset.pauseLabel);
      label();
      btn.addEventListener('click', () => {
        userPaused.set(v, !userPaused.get(v));
        label();
        sync();
      });
      v.addEventListener('play', () => mediaOf(slide).classList.remove('is-paused'));
    });

    new IntersectionObserver((entries) => {
      inView = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.25 }).observe(root);
    document.addEventListener('visibilitychange', sync);

    const select = (next) => {
      next = (next + slides.length) % slides.length;
      if (next === index) return;
      const prev = slides[index];
      const target = slides[next];
      index = next;
      if (count) count.textContent = `${pad(next + 1)} / ${pad(slides.length)}`;
      prev.hidden = true;
      prev.classList.remove('is-active');
      target.hidden = false;
      target.classList.add('is-active');
      sync();
      const gsap = window.gsap;
      if (!gsap || reduced.matches) return;
      gsap.fromTo(target.querySelectorAll('[data-lfv-in]'), { autoAlpha: 0, y: 18 },
        { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out', stagger: 0.05, clearProps: 'opacity,visibility,transform' });
      gsap.fromTo(mediaOf(target), { autoAlpha: 0, scale: 0.98 },
        { autoAlpha: 1, scale: 1, duration: 0.7, ease: 'power3.out', clearProps: 'opacity,visibility,transform' });
    };

    const prevBtn = root.querySelector('[data-lfv-prev]');
    const nextBtn = root.querySelector('[data-lfv-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => select(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => select(index + 1));
    if (slides.length > 1 && typeof window.lsLoadGsap === 'function' && !reduced.matches) window.lsLoadGsap(root.dataset.gsapSrc).catch(() => {});

    root.addEventListener('shopify:block:select', (e) => {
      const i = slides.findIndex((s) => s.contains(e.target));
      if (i > -1) select(i);
    });
  };

  const boot = () => document.querySelectorAll('[data-lfv]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
